import React from "react";
import DealReview from "../Components/Ambassador/Management/DealReview";

const AmbassadorDealReviewPage: React.FC = () => <DealReview />;

export default AmbassadorDealReviewPage;
